import axios from 'axios';

// Replace with your API URL
// const API_URL = '/api/get/inspection/data';

const fetchInspections = async () => {
    const token = localStorage.getItem('token');
    
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/get/inspection/data`, {
            headers: {
                Authorization: `Bearer ${token}`, // Use the provided token
            }
        });

        if (response.data.status) {
            return response.data.data; // Return the data from the response
        } else {
            throw new Error(response.data.message); // Handle error from API response
        }
    } catch (error) {
        // Log detailed error message for debugging
        if (error.response) {
            // The request was made and the server responded with a status code
            throw new Error(`API Error: ${error.response.data.message || 'Unknown error'}`);
        } else if (error.request) {
            // The request was made but no response was received
            throw new Error('No response received from API');
        } else {
            // Something else happened during the setup of the request
            throw new Error(`Error setting up request: ${error.message}`);
        }
    }
};

export { fetchInspections };

